import React from 'react'


interface Props {
  className?: string
}


const CrossSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className={props.className}>
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"><path d="M5.5 15.5l10-10M15.5 15.5l-10-10z" /></g>
    </svg>
  )
}


CrossSvg.defaultProps = {
  className: 'w-8 h-8 strokeCurrent text-black'
}


export default CrossSvg;